import { useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import Navigation from './components/Navigation'
import Hero from './components/Hero'
import Technology from './components/Technology'
import Features from './components/Features'
import Services from './components/Services'
import PartnerCarousel from './components/PartnerCarousel'
import FintechShowcase from './components/FintechShowcase'
import TestimonialToaster from './components/TestimonialToaster'
import ContactModal from './components/ContactModal'
import FloatingContactButton from './components/FloatingContactButton'
import FAQ from './components/FAQ'
import Footer from './components/Footer'
import PrivacyPolicy from './pages/privacy-policy'
import TermsOfService from './pages/terms-of-service'
import CookiePolicy from './pages/cookie-policy'
import ScrollToTop from './components/ScrollToTop'


function App() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  
  const openContactModal = () => setIsContactModalOpen(true)
  const closeContactModal = () => setIsContactModalOpen(false)
    
  return (
    <Router>
      {/* <I18nextProvider i18n={i18n}> */}
        <div className="">
          <Navigation onContactClick={openContactModal} />
          <div className="">
            <Routes>
            <Route path="/" element={
              <>
                <Hero onContactClick={openContactModal} />
                <Services />
                <PartnerCarousel />
                <FintechShowcase />
                <Features onContactClick={openContactModal} />
                <Technology />
                <FAQ onContactClick={openContactModal} />
                <TestimonialToaster />
                <FloatingContactButton onClick={openContactModal} />
                <ScrollToTop />
                <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} />
              </>
            } />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
          </Routes>
        </div>
        <Footer />
      </div>
      {/* </I18nextProvider> */}
    </Router>
  )
}

export default App
